import { FilterType, Filter, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { orderBy } from 'lodash';

const key = FilterKey.NATIONALITY;
export const getNationalityFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const nationalityFilterOptions = filterOptions?.nationality || [];

  const options = nationalityFilterOptions.map(nationality => {
    return {
      label: nationality,
      value: nationality,
      checked: filters.some(filter => filter === nationality),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Nationality',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
